import { LIST_CATEGORY_GROUPS } from '../config';

export default function (state = [], action) {
    switch (action.type) {
        case LIST_CATEGORY_GROUPS:
            return action.payload;
        default:
            return state;
    }
}
